import { Native } from '@givebacks/api';
import { usePlatformService } from 'core/Hooks';

import chromeExtension from '../../utils/chromeExtension';
import useGtmServices from '../useGtmServices';

export const usePlatformExtension = () => {
  const Platform = usePlatformService();
  const GtmService = useGtmServices();

  const installPlatformExtension = Platform.select({
    native: () => Native.postMessage('StartExtensionInstallation'),
    chrome: () => chromeExtension.download(),
    //⬇️ tbd??
    mobileBrowser: () => null,
    default: () => null,
  });

  const gtmTrackExtensionInstallClick = () => {
    return GtmService.click(installPlatformExtension, {
      type: 'button',
      action: 'install_extension',
      label: Platform.OS,
    });
  };

  const platformExtension = {
    installPlatformExtension: gtmTrackExtensionInstallClick,
  };

  return platformExtension;
};
